// extracted by mini-css-extract-plugin
module.exports = {"gallery__container":"ImageGallery_gallery__container__21b8N","gallery__image":"ImageGallery_gallery__image__35jkc"};